import React from 'react';

import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

interface ConfirmationDialogProps {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export const DeleteLocationsFromGroupConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <ConfirmDialog
      dialogTitle='Remove Locations from Location Group'
      confirmButtonText='Remove'
      open={true}
      onClose={onClose}
      confirmButtonProps={{
        onClick: onConfirm,
        color: 'error',
        disabled: loading,
      }}
    >
      {loading && <LinearProgress />}

      <Typography>
        Are you sure you would like to remove these Locations from this Group? This will not delete
        the locations, only their grouping.
      </Typography>
    </ConfirmDialog>
  );
};
